// src/redux/store.js
import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import logger from 'redux-logger';
import { thunk } from 'redux-thunk';  // ✅ Correct: named import with { }

import rootReducer from './root-reducer';

// ===== REDUX PERSIST CONFIG =====
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['cart']
};

// ===== PERSISTED REDUCER =====
const persistedReducer = persistReducer(persistConfig, rootReducer);

// ===== MIDDLEWARE =====
const middlewares = [thunk];

if (process.env.NODE_ENV === 'development') {
  middlewares.push(logger);
}

// ===== CREATE STORE =====
const store = createStore(
  persistedReducer,
  applyMiddleware(...middlewares)
);

// ===== PERSISTOR =====
const persistor = persistStore(store);

export { store, persistor };